import {
  FOLLOW_ON_STUDY_TYPE,
  STUDY_TYPE_OPTIONS,
  VIRTU_OX_STUDY_TYPE_OPTIONS,
} from '@/entities/study';

/**
 * Study type select options whose value is the readable study type name instead of its numeric code. Built by mapping STUDY_TYPE_OPTIONS so both label and value take each item's value field.
 *
 * @returns Study type options keyed by name.
 */
const NON_NUMBER_STUDY_TYPE_OPTIONS = STUDY_TYPE_OPTIONS.map((item) => ({
  label: item.value,
  value: item.value,
}));

/**
 * Study type options for the edit study details form with the follow-on type removed. Derived by filtering NON_NUMBER_STUDY_TYPE_OPTIONS to drop the entry whose value equals FOLLOW_ON_STUDY_TYPE.
 *
 * @returns Study type options excluding the follow-on type.
 */
const STUDY_OPTIONS = NON_NUMBER_STUDY_TYPE_OPTIONS.filter(
  ({ value }) => value !== FOLLOW_ON_STUDY_TYPE,
);

/**
 * VirtuOx study type select options whose value is the readable study type name instead of its numeric code. Built by mapping VIRTU_OX_STUDY_TYPE_OPTIONS so both label and value take each item's value field.
 *
 * @returns VirtuOx study type options keyed by name.
 */
const VIRTU_OX_NON_NUMBER_STUDY_TYPE_OPTIONS = VIRTU_OX_STUDY_TYPE_OPTIONS.map((item) => ({
  label: item.value,
  value: item.value,
}));

const EDIT_DRAWER_KEY = {
  STUDY_INFO: 'STUDY_INFO',
  REFERRING_PHYSICIAN: 'REFERRING_PHYSICIAN',
  INTEREPTING_PHYSICIAN: 'INTEREPTING_PHYSICIAN',
  DIAGNOSIS: 'DIAGNOSIS',
  PHYSICIAN_NOTES: 'PHYSICIAN_NOTES',
};

export {
  EDIT_DRAWER_KEY,
  NON_NUMBER_STUDY_TYPE_OPTIONS,
  STUDY_OPTIONS,
  VIRTU_OX_NON_NUMBER_STUDY_TYPE_OPTIONS,
};
